import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Button, Card, Divider, CardContent, Typography, Select, MenuItem } from '@material-ui/core';
import StarRateIcon from '@material-ui/icons/StarRate';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import RemoveIcon from '@material-ui/icons/UnfoldLess';

import {Radar} from 'react-chartjs-2';

// const data = {
//     labels  : ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
//     datasets: [
//         {
//             label                    : 'My First dataset',
//             backgroundColor          : 'rgba(179,181,198,0.2)',
//             borderColor              : 'rgba(179,181,198,1)',
//             pointBackgroundColor     : 'rgba(179,181,198,1)',
//             pointBorderColor         : '#fff',
//             pointHoverBackgroundColor: '#fff',
//             pointHoverBorderColor    : 'rgba(179,181,198,1)',
//             data                     : [65, 59, 90, 81, 56, 55, 40]
//         },
//         {
//             label                    : 'My Second dataset',
//             backgroundColor          : 'rgba(255,99,132,0.2)',
//             borderColor              : 'rgba(255,99,132,1)',
//             pointBackgroundColor     : 'rgba(255,99,132,1)',
//             pointBorderColor         : '#fff',
//             pointHoverBackgroundColor: '#fff',
//             pointHoverBorderColor    : 'rgba(255,99,132,1)',
//             data                     : [28, 48, 40, 19, 96, 27, 100]
//         }
//     ]
// };

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
});

class LembarRaporMutu extends Component {
    state = {
        error:0,
        routeParams:{
            jenis_rapor_id: 2,
            tahun: localStorage.getItem('tahun')
        },
        valueTab: 0,
        offset: 0,
        total: 0,
        openDialog: false,
        completed: 0,
        fullWidth: true,
        maxWidth: 'sm',
        tampilCheck: ['none','none','none','none','none','none'],
        data_tahun: {
            rows: []
        },
        data_wilayah: {
            rows: [{
                nama_sekolah: '',
                nama_kab: ''
            }]
        }
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        // this.props.setJudul('Rapor Mutu');
        localStorage.setItem('jenis_rapor_id',2);
        
        this.setState({
            routeParams: {
                ...this.state.routeParams,
                tahun: localStorage.getItem('tahun'),
                pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id,
                sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                token: localStorage.getItem('jwt_token'),
                instrumen_id: localStorage.getItem('instrumen_id'),
                start: 0,
                jenis_rapor_id: localStorage.getItem('jenis_rapor_id'),
                jenis_chart: 'radar_tahun'
            }
        },()=>{

            this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{

                this.props.getRaporMutu(this.state.routeParams).then((result)=>{
                    console.log(this.props.rapor_mutu);
                });
                
                this.props.setDataTahun(this.props.rapor_mutu_radar);

                // console.log(this.props.data_tahun.rows);
                let nilaiSekolah = 0
                // this.props.data_tahun.rows.map((option)=>{
                //     nilaiSekolah = nilaiSekolah+parseFloat(option.r19);
                // })

                const array = this.props.data_tahun.rows;
                for (let index = 0; index < array.length; index++) {
                    const option = array[index];
                    nilaiSekolah = nilaiSekolah+parseFloat(option.r19);
                }

                nilaiSekolah = parseFloat(nilaiSekolah / this.props.data_tahun.rows.length).toFixed(2)

                let predikat = null;
                if(parseFloat(nilaiSekolah)>0 && parseFloat(nilaiSekolah)<=2.04){
                    predikat = 'Menuju SNP 1';
                }else if(parseFloat(nilaiSekolah)>2.04 && parseFloat(nilaiSekolah) <=3.70){
                    predikat = 'Menuju SNP 2';
                }else if(parseFloat(nilaiSekolah)>3.70 && parseFloat(nilaiSekolah) <=5.06){
                    predikat = 'Menuju SNP 3';
                }else if(parseFloat(nilaiSekolah)>5.06 && parseFloat(nilaiSekolah) <=6.66){
                    predikat = 'Menuju SNP 4';
                }else if(parseFloat(nilaiSekolah)>6.66){
                    predikat = 'SNP';
                }

                this.setState({
                    nilaiSekolah: nilaiSekolah,
                    predikat: predikat,
                    routeParams: {
                        ...this.state.routeParams,
                        jenis_chart: 'radar_wilayah'
                    }
                },()=>{
                    this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                        this.props.setDataWilayah(this.props.rapor_mutu_radar);
                        // this.setState({
                        //     data_wilayah: this.props.rapor_mutu_radar
                        // });
                    });
                });

                // this.setState({
                //     data_tahun: this.props.rapor_mutu_radar
                // },()=>{
                //     this.setState({
                //         routeParams: {
                //             ...this.state.routeParams,
                //             jenis_chart: 'radar_wilayah'
                //         }
                //     },()=>{
                //         this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                //             this.setState({
                //                 data_wilayah: this.props.rapor_mutu_radar
                //             });
                //         });
                //     });
                // });
            });
        });

    }

    onChangeTahun = (e) => {

        this.setState({
            routeParams: {
                ...this.state.routeParams,
                tahun: e.target.value,
                pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id,
                sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                token: localStorage.getItem('jwt_token'),
                instrumen_id: localStorage.getItem('instrumen_id'),
                start: 0,
                jenis_rapor_id: localStorage.getItem('jenis_rapor_id'),
                jenis_chart: 'radar_tahun'
            }
        },()=>{
            this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                
                this.props.setDataTahun(this.props.rapor_mutu_radar);

                this.setState({
                    routeParams: {
                        ...this.state.routeParams,
                        jenis_chart: 'radar_wilayah'
                    }
                },()=>{
                    this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                        this.props.setDataWilayah(this.props.rapor_mutu_radar);
                        // this.setState({
                        //     data_wilayah: this.props.rapor_mutu_radar
                        // });
                    });
                });
                // this.props.setDataTahun(this.props.rapor_mutu_radar).then((result)=>{
                //     alert('oke');
                // });

                // this.setState({
                //     data_tahun: this.props.rapor_mutu_radar
                // },()=>{
                //     this.setState({
                //         routeParams: {
                //             ...this.state.routeParams,
                //             jenis_chart: 'radar_wilayah'
                //         }
                //     },()=>{
                //         this.props.getRaporMutuRadar(this.state.routeParams).then((result)=>{
                //             this.setState({
                //                 data_wilayah: this.props.rapor_mutu_radar
                //             });
                //         });
                //     });
                // });
            });
        });
        localStorage.setItem('tahun_rapor', e.target.value);
    }

    printDiv = () => {
        // let printContents = document.getElementById('printableArea').innerHTML;
        // let originalContents = document.body.innerHTML;

        // document.body.innerHTML = printContents;

        window.print();

        // document.body.innerHTML = originalContents;
        // var content = document.getElementById("printableArea");
        // var pri = document.getElementById("ifmcontentstoprint").contentWindow;
        // pri.document.open();
        // pri.document.write(content.innerHTML);
        // pri.document.close();
        // pri.focus();
        // pri.print();
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FuseAnimate
                animation="transition.slideLeftIn"
                duration={400}
                delay={400}
            >
            <div style={{width: '100%', padding: '10px'}} className="konten-utama">
                <iframe title="ifmcontentstoprint" id="ifmcontentstoprint" style={{height: '0px', width: '0px', position: 'absolute'}}></iframe>
                <Grid container className={classes.root} spacing={16}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent>
                                <Select
                                    value={this.state.routeParams.tahun}
                                    onChange={this.onChangeTahun}
                                    style={{width:'100%'}}
                                >
                                    <MenuItem value={"2019"}>Rapor Mutu Tahun 2019</MenuItem>
                                    <MenuItem value={"2018"}>Rapor Mutu Tahun 2018</MenuItem>
                                    <MenuItem value={"2017"}>Rapor Mutu Tahun 2017</MenuItem>
                                    <MenuItem value={"2016"}>Rapor Mutu Tahun 2016</MenuItem>
                                </Select>
                            </CardContent>
                        </Card>
                        {/* <br/>
                        <br/> */}
                        {/* <Typography variant="subheading">
                            Tanggal penghitungan rapor terakhir:
                            {this.props.timeline.map((option)=>{
                                if(option.jenis_timeline_id === 2){
                                    return (
                                        <span>&nbsp;{option.tanggal}</span>
                                    )
                                }
                            })}
                        </Typography> */}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Paper elevation={1} className="p-8" style={{minHeight: '100px'}}>
                            {/* <Typography variant="subheading">
                                Tanggal penghitungan rapor terakhir:
                                {this.props.timeline.map((option)=>{
                                    if(option.jenis_timeline_id === 2){
                                        return (
                                            <span>&nbsp;{option.tanggal}</span>
                                        )
                                    }
                                })}
                            </Typography> */}
                            <Typography variant="title" style={{textAlign:'center'}}>Tahun Pemetaan</Typography>
                            <br/>
                            <div style={{width:'100%', textAlign:'right'}}>
                                <Button className="buttonPrint" variant="raised" size="large" color="primary" onClick={this.printDiv} style={{marginRight:'8px'}}>
                                    Print Rapor Mutu
                                </Button>
                            </div>
                            <br/>
                            <Radar data={this.props.data_tahun} options={{
                            legend: {
                                position: 'top'
                            },
                            title: {
                                display: true,
                                text: 'Chart.js Radar Chart'
                            },
                            scale: {
                                reverse: false,
                                gridLines: {
                                    color: ['#cccccc']
                                },
                                ticks: {
                                    beginAtZero: true,
                                    suggestedMax: 7,
                                    suggestedMin: 0
                                }
                            }}} />
                            <br/>
                        </Paper>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                        <Paper elevation={1} className="p-8" style={{minHeight: '100px'}}>
                            <Typography variant="title" style={{textAlign:'center'}}>Rata-rata Wilayah Pemetaan</Typography>
                            <br/>
                            <Radar data={this.props.data_wilayah}/>
                            <br/>
                        </Paper>
                    </Grid> */}
                    {/* <div id="printableArea"> */}
                    <Grid item xs={12} sm={12}>
                        <Paper className="p-8" style={{textAlign:'center', minHeight:'100px'}}>
                            <Typography variant="subheading" style={{marginBottom:'10px', fontSize: '2vh'}}>
                                Nilai Rapor Mutu
                            </Typography>
                            <Typography variant="display2" style={{fontSize:'6vh'}}>
                                {this.state.nilaiSekolah}
                            </Typography>
                            <Typography variant="caption">
                                Predikat: {this.state.predikat}
                            </Typography>
                            {this.state.predikat === 'Menuju SNP 1' && <div><StarRateIcon/></div>}
                            {this.state.predikat === 'Menuju SNP 2' && <div><StarRateIcon/><StarRateIcon/></div>}
                            {this.state.predikat === 'Menuju SNP 3' && <div><StarRateIcon/><StarRateIcon/><StarRateIcon/></div>}
                            {this.state.predikat === 'Menuju SNP 4' && <div><StarRateIcon/><StarRateIcon/><StarRateIcon/><StarRateIcon/></div>}
                            {this.state.predikat === 'SNP' && <div><StarRateIcon/><StarRateIcon/><StarRateIcon/><StarRateIcon/><StarRateIcon/></div>}
                            <br/>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Paper elevation={1} className="p-8" style={{minHeight: '100px'}}>
                        {/* <Typography variant="title" style={{textAlign:'center'}}>Tahun Pemetaan</Typography> */}
                            <Paper elevation={0} className="p-8">
                                <Grid container>
                                    <Grid items xs={12} sm={8}>
                                        Standar
                                    </Grid>
                                    <Grid item xs={12} sm={4} className="hilangDiMobile">
                                        <Grid container>
                                            {/* <Grid items xs={3} sm={3} style={{textAlign:'center'}}>
                                                Rapor 2016
                                                <Divider/>
                                                <Grid container className="hilangDiMobile">
                                                    <Grid item xs={6}>
                                                        Nilai
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        Kategori
                                                    </Grid>
                                                </Grid>
                                            </Grid> */}
                                            {/* <Grid items xs={3} sm={3} style={{textAlign:'center'}}>
                                                Rapor 2017
                                                <Divider/>
                                                <Grid container className="hilangDiMobile">
                                                    <Grid item xs={6}>
                                                        Nilai
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        Kategori
                                                    </Grid>
                                                </Grid>
                                            </Grid> */}
                                            {/* <Grid items xs={6} sm={6} style={{textAlign:'center'}}>
                                                Rapor 2018
                                                <Divider/>
                                                <Grid container className="hilangDiMobile">
                                                    <Grid item xs={6}>
                                                        Nilai
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        Kategori
                                                    </Grid>
                                                </Grid>
                                            </Grid> */}
                                            <Grid items xs={12} sm={12} style={{textAlign:'center'}}>
                                                <b>Rapor 2020</b>
                                                <Divider/>
                                                <Grid container className="hilangDiMobile">
                                                    <Grid item xs={6}>
                                                        <b>Nilai</b>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <b>Kategori</b>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider/>
                            </Paper>
                            {this.props.data_tahun.rows.map((option)=>{
                                return (
                                    <Paper elevation={0} className="p-8">
                                        <Grid container>
                                            <Grid items xs={12} sm={8} style={{paddingRight:'10px', color:'#1976d2'}}>
                                                <b>{option.nomor}. {option.uraian}</b>
                                            </Grid>
                                            <Grid items xs={12} sm={4}>
                                                <Grid container>
                                                    {/* <Grid items xs={3} sm={3} style={{textAlign:'center'}}>
                                                        <Grid container>
                                                            <Grid item xs={12} sm={6} className="hilangDiDesktop">
                                                                Rapor 2016
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {parseFloat(option.r16 = option.r16 || 0).toFixed(2)}
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {parseFloat(option.r16 = option.r16 || 0).toFixed(2) > 0 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r16 = option.r16 || 0).toFixed(2) > 2.04 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r16 = option.r16 || 0).toFixed(2) > 3.70 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r16 = option.r16 || 0).toFixed(2) > 5.06 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r16 = option.r16 || 0).toFixed(2) > 6.66 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid items xs={3} sm={3} style={{textAlign:'center'}}>
                                                        <Grid container>
                                                            <Grid item xs={12} sm={6} className="hilangDiDesktop">
                                                                Rapor 2017
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {parseFloat(option.r17 = option.r17 || 0).toFixed(2)}
                                                                {parseFloat(option.r17) > parseFloat(option.r16) &&
                                                                    <ArrowDropUpIcon style={{marginTop:'-20px', color:'green'}} />
                                                                }
                                                                {parseFloat(option.r17) < parseFloat(option.r16) &&
                                                                    <ArrowDropDownIcon style={{marginTop:'-20px', color:'red'}}/>
                                                                }
                                                                {parseFloat(option.r17) === parseFloat(option.r16) &&
                                                                    <RemoveIcon style={{marginTop:'-20px', color:'#434343'}}/>
                                                                }
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {parseFloat(option.r17 = option.r17 || 0).toFixed(2) > 0 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r17 = option.r17 || 0).toFixed(2) > 2.04 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r17 = option.r17 || 0).toFixed(2) > 3.70 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r17 = option.r17 || 0).toFixed(2) > 5.06 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r17 = option.r17 || 0).toFixed(2) > 6.66 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid> */}
                                                    {/* <Grid items xs={6} sm={6} style={{textAlign:'center'}}>
                                                        <Grid container>
                                                            <Grid item xs={12} sm={6} className="hilangDiDesktop">
                                                                Rapor 2018
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <b>{parseFloat(option.r18 = option.r18 || 0).toFixed(2)}</b>
                                                                {parseFloat(option.r18) > parseFloat(option.r17) &&
                                                                    <ArrowDropUpIcon style={{marginTop:'-20px', color:'green'}} />
                                                                }
                                                                {parseFloat(option.r18) < parseFloat(option.r17) &&
                                                                    <ArrowDropDownIcon style={{marginTop:'-20px', color:'red'}}/>
                                                                }
                                                                {parseFloat(option.r18) === parseFloat(option.r17) &&
                                                                    <RemoveIcon style={{marginTop:'-20px', color:'#434343'}}/>
                                                                }
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {parseFloat(option.r18 = option.r18 || 0).toFixed(2) >= 0 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r18 = option.r18 || 0).toFixed(2) > 2.04 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r18 = option.r18 || 0).toFixed(2) > 3.70 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r18 = option.r18 || 0).toFixed(2) > 5.06 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r18 = option.r18 || 0).toFixed(2) > 6.66 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid> */}
                                                    <Grid items xs={12} sm={12} style={{textAlign:'center'}}>
                                                        <Grid container>
                                                            <Grid item xs={12} sm={6} className="hilangDiDesktop">
                                                                Rapor 2020
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <b>{parseFloat(option.r19 = option.r19 || 0).toFixed(2)}</b>
                                                                {parseFloat(option.r19) > parseFloat(option.r18) &&
                                                                    <ArrowDropUpIcon style={{marginTop:'-20px', color:'green'}} />
                                                                }
                                                                {parseFloat(option.r19) < parseFloat(option.r18) &&
                                                                    <ArrowDropDownIcon style={{marginTop:'-20px', color:'red'}}/>
                                                                }
                                                                {parseFloat(option.r19) === parseFloat(option.r18) &&
                                                                    <RemoveIcon style={{marginTop:'-20px', color:'#434343'}}/>
                                                                }
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                {parseFloat(option.r19 = option.r19 || 0).toFixed(2) >= 0 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 2.04 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 3.70 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 5.06 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 6.66 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Divider/>
                                    </Paper>
                                )
                            })}
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Paper elevation={1} className="p-8" style={{minHeight: '100px'}}>
                            <Paper elevation={0} className="p-8">
                                <Grid container>
                                    <Grid items xs={12} sm={8}>
                                        Standar / Indikator / Sub Indikator
                                    </Grid>
                                    <Grid item xs={12} sm={4} className="hilangDiMobile">
                                        <Grid container>
                                            <Grid item xs={12} sm={12} style={{textAlign:'center'}}>
                                                <b>Rapor</b>
                                                <Divider/>
                                                <Grid container className="hilangDiMobile">
                                                    <Grid item xs={4}>
                                                        <b>Sumber</b>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <b>Nilai</b>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <b>Kategori</b>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider/>
                            </Paper>
                            {this.props.rapor_mutu.rows.map((option)=>{
                                return (
                                    <Paper elevation={0} className="p-8">
                                        <Grid container>
                                            <Grid item xs={12} sm={8} style={{paddingRight:'10px', color:'#1976d2'}}>
                                                <b style={{fontSize:'20px'}}>{option.nomor} {option.uraian}</b>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                {/* <Grid container>
                                                <Grid item xs={12} sm={12} style={{textAlign:'center'}}> */}
                                                <Grid container>
                                                    <Grid item xs={12} sm={4} style={{textAlign:'center'}}>
                                                        &nbsp;
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} style={{textAlign:'center'}}>
                                                        <b>{parseFloat(option.r19 = option.r19 || 0).toFixed(2)}</b>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} style={{textAlign:'center'}}>
                                                        {parseFloat(option.r19 = option.r19 || 0).toFixed(2) >= 0 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                        {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 2.04 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                        {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 3.70 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                        {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 5.06 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                        {parseFloat(option.r19 = option.r19 || 0).toFixed(2) > 6.66 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                    </Grid>
                                                </Grid>
                                                {/* </Grid>
                                                </Grid> */}
                                            </Grid>
                                            {option.indikator.rows.map((optionIndikator)=>{
                                                return (
                                                    <Grid item xs={12} sm={12} style={{paddingRight:'10px', color:'#FE6465'}}>
                                                        <Grid container spacing={32}>
                                                            <Grid item sm={8}>
                                                                <b>{optionIndikator.nomor} {optionIndikator.uraian}</b>
                                                            </Grid>
                                                            <Grid item sm={4}>
                                                                <Grid container>
                                                                    <Grid item sm={4} style={{textAlign:'center'}}>
                                                                        &nbsp;
                                                                    </Grid>
                                                                    <Grid item sm={4} style={{textAlign:'center'}}>
                                                                        <b>{parseFloat(optionIndikator.r19 = optionIndikator.r19 || 0).toFixed(2)}</b>
                                                                    </Grid>
                                                                    <Grid item sm={4} style={{textAlign:'center', paddingLeft:'12px'}}>
                                                                        {parseFloat(optionIndikator.r19 = optionIndikator.r19 || 0).toFixed(2) >= 0 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                        {parseFloat(optionIndikator.r19 = optionIndikator.r19 || 0).toFixed(2) > 2.04 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                        {parseFloat(optionIndikator.r19 = optionIndikator.r19 || 0).toFixed(2) > 3.70 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                        {parseFloat(optionIndikator.r19 = optionIndikator.r19 || 0).toFixed(2) > 5.06 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                        {parseFloat(optionIndikator.r19 = optionIndikator.r19 || 0).toFixed(2) > 6.66 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Divider/>
                                                        {optionIndikator.sub_indikator.rows.map((optionSubIndikator)=>{
                                                            return (
                                                                <Grid item xs={12} sm={12} style={{paddingRight:'10px', color: (optionSubIndikator.sumber === 'Tidak Digunakan' ? '#cccccc' : '#56508C'), textDecoration: (optionSubIndikator.sumber === 'Tidak Digunakan' ? 'line-through' : 'none')}}>
                                                                    <Grid container spacing={32}>
                                                                        <Grid item sm={8}>
                                                                            <b>{optionSubIndikator.nomor} {optionSubIndikator.uraian}</b>
                                                                        </Grid>
                                                                        <Grid item sm={4} style={{textAlign:'center'}}>
                                                                            <Grid container>
                                                                                <Grid item sm={4} style={{textAlign:'center', fontSize:'12px'}}>
                                                                                    {optionSubIndikator.sumber}
                                                                                </Grid>
                                                                                <Grid item sm={4} style={{textAlign:'center', paddingLeft:'12px'}}>
                                                                                    <b>{parseFloat(optionSubIndikator.r19 = optionSubIndikator.r19 || 0).toFixed(2)}</b>
                                                                                </Grid>
                                                                                <Grid item sm={4} style={{textAlign:'center', paddingLeft:'32px'}}>
                                                                                    {parseFloat(optionSubIndikator.r19 = optionSubIndikator.r19 || 0).toFixed(2) >= 0 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                                    {parseFloat(optionSubIndikator.r19 = optionSubIndikator.r19 || 0).toFixed(2) > 2.04 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                                    {parseFloat(optionSubIndikator.r19 = optionSubIndikator.r19 || 0).toFixed(2) > 3.70 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                                    {parseFloat(optionSubIndikator.r19 = optionSubIndikator.r19 || 0).toFixed(2) > 5.06 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                                    {parseFloat(optionSubIndikator.r19 = optionSubIndikator.r19 || 0).toFixed(2) > 6.66 && <StarRateIcon className="bintangPrint" style={{fontSize:'15px'}}/>}
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Divider/>                                                                
                                                                </Grid>
                                                            )
                                                        })}
                                                        <br/>
                                                    </Grid>
                                                    
                                                )
                                            })}
                                        </Grid>
                                        <Divider/>
                                    </Paper>
                                )
                            })}
                        </Paper>
                    </Grid>
                    {/* </div> */}
                </Grid>
            </div>
            </FuseAnimate>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        prosesRaporMutu: Actions.prosesRaporMutu,
        getProsesRapor: Actions.getProsesRapor,
        hitungFinalSkor: Actions.hitungFinalSkor,
        hitungHasilSubl: Actions.hitungHasilSubl,
        hitungHasilIndl: Actions.hitungHasilIndl,
        hitungHasilStdl: Actions.hitungHasilStdl,
        hitungMasterPMP: Actions.hitungMasterPMP,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        getRaporMutu: Actions.getRaporMutu,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah,
        getTimeline: Actions.getTimeline
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        final_skor: RaporMutu.final_skor,
        rapor_mutu_radar: RaporMutu.rapor_mutu_radar,
        rapor_mutu: RaporMutu.rapor_mutu,
        data_tahun: RaporMutu.data_tahun,
        data_wilayah: RaporMutu.data_wilayah,
        timeline: RaporMutu.timeline
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LembarRaporMutu)));



// WEBPACK FOOTER //
// ./src/main/content/RaporMutu/LembarRaporMutu.js